import * as types from "./../types";

const state = {
  isModalOpen: false
};

const getters = {
  [types.image.getters.IS_MODAL_OPEN]: state => {
    return state.isModalOpen;
  }
};

const mutations = {
  [types.image.mutations.MUTATE_MODAL]: (state, payload) => {
    state.isModalOpen = payload;
  }
};

const actions = {
  [types.image.actions.SET_MODAL]: ({ commit }, payload) => {
    commit(types.image.mutations.MUTATE_MODAL, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
